(function () {
  const SELECTOR = 'form[data-vse-b2b="true"]';
  let pendingForm = null;

  const modal = () => document.querySelector('[data-vse-b2b-modal]');

  function openModal(form) {
  pendingForm = form;
  const m = modal();
  if (!m) {
    form.dataset.vseConfirmed = 'true';
    form.requestSubmit();
    return;
  }
  m.hidden = false;
  void m.offsetWidth; // erzwingt Reflow, damit die Transition greift
  requestAnimationFrame(() => m.classList.add('vse-b2b-overlay--visible'));
  document.body.style.overflow = 'hidden';
  m.querySelector('[data-vse-b2b-confirm]').focus();
}

function closeModal() {
  const m = modal();
  if (!m) { pendingForm = null; return; }
  m.classList.remove('vse-b2b-overlay--visible');
  const onEnd = () => {
    m.hidden = true;
    m.removeEventListener('transitionend', onEnd);
  };
  m.addEventListener('transitionend', onEnd);
  document.body.style.overflow = '';
  pendingForm = null;
}

  // Capture-Phase auf document: läuft VOR dem Submit-Handler des Themes
  document.addEventListener('submit', function (e) {
    const form = e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!form) return;
    if (form.dataset.vseConfirmed === 'true') return; // schon bestätigt → durchlassen
    e.preventDefault();
    e.stopImmediatePropagation();
    openModal(form);
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vse-b2b-cancel]')) {
      closeModal();
      return;
    }
    if (e.target.closest('[data-vse-b2b-confirm]')) {
  if (!pendingForm) return closeModal();
  const form = pendingForm;

  const stamp = new Date().toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  });
  let input = form.querySelector('[data-vse-b2b-prop]');
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[B2B-Bestätigung]';
    input.setAttribute('data-vse-b2b-prop', '');
    form.appendChild(input);
  }
  input.value = 'Unternehmerkauf gem. § 14 BGB bestätigt am ' + stamp + ' Uhr';

  form.dataset.vseConfirmed = 'true';
  closeModal(); // spielt die Fly-out-Animation ab

  setTimeout(() => {
    form.requestSubmit();
    setTimeout(() => { delete form.dataset.vseConfirmed; }, 1000);
  }, 220); // knapp unter der 300ms-Transition-Dauer oben
}
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && pendingForm) closeModal();
  });
})();